module.exports = __webpack_public_path__ + "img/18.aeae0e65.jpg";